/**
 * Created on 2017/3/20.
 *
 */
define('controllers/myaccount/balance/gift-balance-detail.ctrl',['app','mainCons'], function (app,mainCons) {
    //订单详情contorller
    app.controller('GiftBalanceDetailCtrl', ['$q','$filter','$scope','OpenTrade','auiBalanceService',
        function ($q,$filter,$scope,OpenTrade,auiBalanceService) {

            var serviceItem = $scope.$parent.serviceItem;
            var ParentModel = $scope.$parent.Model;
            var signParty = $scope.signParty = $scope.$parent.signParty;
            $scope.currentType = mainCons.balanceConstant.currentTypes[signParty];
            $scope.currencyUnit = mainCons.balanceConstant.currentUnits[signParty];
            $scope.promoteAccountName = mainCons.balanceConstant.accountnTypes.promoteAccount[signParty];
            $scope.ppsAccountName = mainCons.balanceConstant.accountnTypes.ppsAccount[signParty];

            var Model = $scope.Model = {
                DialogTitle : '',
                //现金
                cashBalance: 0,
                //置换
                replaceBalance: 0,
                //赠送
                giftBalance: 0,
                //返利
                rebaseBalance: 0,
                //赠送分页
                gift:{
                    query: {
                        pagination: {
                            currentPage: 1,// 当前页
                            itemsPerPage : 10,
                            pagesLength: 10,// 显示的页码数量,
                            totalCount: 0,
                            noItems: "No oders",
                            position: 'up',
                            hidePage:'hide',
                            onChange: function(){
                                queryGiftList([3,4]);
                            }
                        }
                    }
                },
                //资源置换分页
                replaceRes: {
                    query: {
                        pagination: {
                            currentPage: 1,// 当前页
                            itemsPerPage : 10,
                            pagesLength: 10,// 显示的页码数量,
                            totalCount: 0,
                            noItems: "No order",
                            position: 'up',
                            hidePage:'hide',
                            onChange: function(){
                                queryGiftList([2]);
                            }
                        }
                    }
                }
            };

            //初始化controller
            init();
            function init(){
                if(serviceItem == ParentModel.inappType){
                    Model.DialogTitle=$scope.promoteAccountName;
                    Model.cashBalance =ParentModel.inappBalanceCash;
                    Model.replaceBalance=ParentModel.inappBalanceZhihuan;
                    Model.giftBalance=ParentModel.inappBalanceGift;
                    Model.rebaseBalance=ParentModel.inappBalanceRebase;
                }
                else if(serviceItem == ParentModel.innewappType){
                    Model.DialogTitle=$scope.ppsAccountName;
                    Model.cashBalance =ParentModel.inappNewBalanceCash;
                    Model.replaceBalance=ParentModel.inappNewBalanceZhihuan;
                    Model.giftBalance=ParentModel.inappNewBalanceGift;
                    Model.rebaseBalance=ParentModel.inappNewBalanceRebase;
                }
                //查询赠送
                queryGiftList([3,4]);
                //查询资源置换
                queryGiftList([2]);
            }
            function queryGiftList(accountTypes){
                //[3,4]是赠送
                var key = 'gift';
                if(accountTypes && accountTypes.length == 1){
                    key = 'replaceRes';
                }
                var defer = $q.defer();
                if(signParty[0] == 1){
                    signParty = [1,4]
                }
                var queryGiftReq = {
                    version: '1.0',
                    traceUniqueID:auiBalanceService.getTraceUniqueID(),
                    isGetTotalNumber: 1,
                    serviceItem: serviceItem,
                    accountType: accountTypes,
                    signPartys:signParty,
                    pageNo:Model[key].query.pagination.currentPage,
                    pageNum:Model[key].query.pagination.itemsPerPage,
                    isDiffGift:1
                };
                OpenTrade.getGiftBalanceDetails({req: queryGiftReq}).then(function (data) {
                    var balances = data.balances;
                    angular.forEach(balances, function (obj) {
                        var expireDate = $filter('auiDateFormat')(obj.expireDate,"+0000");
                        obj.isExpire = expireDate.getTime() < new Date().getTime();
                    });
                    Model[key + 'Balances'] = balances;
                    Model[key].query.pagination.totalCount = data.total;
                    defer.resolve(data);
                });
                return defer.promise;
            }
        }]);
});
